import { useState, useEffect } from 'react';

export default function FloatingConsultButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToConsultation = () => {
    const element = document.getElementById('consultation');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <button
      onClick={scrollToConsultation}
      className={`fixed top-20 right-6 z-50 px-6 py-4 bg-gradient-to-r from-[#4A90E2] to-[#357ABD] text-white text-base font-bold rounded-full shadow-2xl hover:shadow-3xl hover:scale-110 transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-10 pointer-events-none'
      }`}
      style={{
        animation: isVisible ? 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' : 'none'
      }}
    >
      <i className="ri-customer-service-2-line text-xl"></i>
      <span>상담신청</span>
    </button>
  );
}
